import Tree from "rc-tree";
import "../../assets/scss/rc-tree/rc-tree.scss";
import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { INode } from "../../app/models/node";
import TreeElement from "../common/TreeElement";
import TreeIcon from "../common/TreeIcon";
import { ITenant } from "../../app/models/tenant";

const STYLE = `
.rc-tree-child-tree {
  display: block;
}
.node-motion {
  transition: all .3s;
  overflow-y: hidden;
}
`;

interface IParams {
  tenant: ITenant;
  type: "meetings" | "boards";
  sourceId: number;
  nodes: INode[];
}

const getAllNodes = (nodes: INode[]) => {
  let tempExpanded = nodes.map((n) => n.key);
  nodes.forEach((n) => tempExpanded.push(...getAllNodes(n.children)));
  return tempExpanded;
};

const TreeComponent: React.FC<IParams> = ({ nodes, type, sourceId, tenant }) => {
  const [expanded, setExpanded] = useState<string[]>(getAllNodes(nodes));

  const formatNodes = (tree: INode[]) => {
    let retArray: any[] = [];
    tree.forEach((node) => {
      let childrenNodes = formatNodes(node.children);
      retArray.push({
        key: node.key,
        title: node.hasContent ? (
          <TreeElement
            title={node.title}
            link={
              node.hasContent && tenant
                ? `${tenant.path}/browse/${type}/${sourceId}/content/${node.key}`
                : "/"
            }
          />
        ) : (
          <TreeElement title={node.title} />
        ),
        children: childrenNodes,
        icon: (<TreeIcon hasDocument={node.hasContent} markedAsNew={node.markAsNew}  typology={node.typology}/>),
      });
    });
    return retArray;
  };

  const handleExpand = (key: string) => {
    let copy = [...expanded];
    if (copy.includes(key)) copy = copy.filter((x) => x !== key);
    else copy.push(key);
    setExpanded(copy);
  };

  return (
    <div className="draggable-demo odgTree">
      <style dangerouslySetInnerHTML={{ __html: STYLE }} />
      {nodes.length > 0 && (
        <Tree
          expandedKeys={expanded}
          treeData={formatNodes(nodes)}
          onSelect={(selectedKeys, e) => {
            handleExpand(e.node.key.toString());
          }}
          onExpand={(selectedKeys, e) => {
            handleExpand(e.node.key.toString());
          }}
          showLine={true}
        />
      )}
    </div>
  );
};

export default observer(TreeComponent);
